import React from 'react';
import styles from './SpendingDemandConfirmation.module.scss';

export default function SpendingDemandConfirmation({isUpdate}: {isUpdate?: boolean}) {
  return (
    <div className={styles.confirmation}>
      <div className={styles.confirmation__icon} />
      
      <h2 className={styles.confirmation__title}>
        {isUpdate ? 'Demande modifiée !' : 'Demande envoyée !'}
      </h2>
      
      <p className={styles.confirmation__message}>
        {isUpdate 
          ? 'Votre demande de dépense a bien été modifiée.' 
          : 'Votre demande de dépense a bien été envoyée.'
        }
      </p>
      
      <p className={styles.confirmation__notification}>
        Vous serez notifié lors de son traitement.
      </p>
    </div>
  );
} 